import { ComponentRef, ViewRef } from '@angular/core';

export class ContentRef {

    constructor(public nodes: any[], public viewRef?: ViewRef, public componentRef?: ComponentRef<any>) {
    }

}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/modals/classes/content-ref.ts